import { SimulationDto } from 'models/SimulationDto';
import React from 'react';
import { getCurrencyFormat } from 'utils/getCurrencyFormat';
import 'assets/scss/simulation-card.scss';

type SimulationCardProps = {
	data: SimulationDto;
};

export const SimulationCard = ({ data }: SimulationCardProps) => {
	return (
		<div className="simulation-card-container">
			<div className="simulation-card-container-header">
				<p className="small gris-6">
					Pie de{' '}
					<b>
						{data.downPaymentPercentage}% - {getCurrencyFormat(Number.parseInt(data.downPayment))}
					</b>
				</p>
				<p className="small-bold secondary-color">
					{`${data.discountPercentage}%`} dcto en la tasa
				</p>
			</div>
			<div className="simulation-card-container-body">
				<div id="simulacion-container-body-left">
					<p className="body-small primary-color">{data.installmentNumber} cuotas</p>
					<p className="title-1 warning">
						{getCurrencyFormat(Number.parseInt(data.installmentAmount))}
					</p>
				</div>
				<div
					id="simulacion-container-body-separator"
					style={{
						width: '1px',
						backgroundColor: '#CCCCCC',
					}}
				></div>
				<div id="simulacion-container-body-right">
					<p className="small gris-6">Tasa de intéres mensual</p>
					<p className="title-2 secondary-color" style={{ textAlign: 'center' }}>
						{data.discountInterestRate.replace('.', ',')}
						%
					</p>
					<p className="small" style={{ textAlign: 'center'}}>
						Antes {data.interestRate.replace('.', ',')}%
					</p>
				</div>
			</div>
			<div className="simulation-card-container-sepator"></div>
			<div className="body-small primary-color simulation-card-container-footer">
				<p>
					Costo total del crédito: <b>{getCurrencyFormat(Number.parseInt(data.totalLoanCost))}</b>
				</p>
				<p>
					CAE*: <b>{data.cae.replace('.', ',')}%</b>
				</p>
			</div>
		</div>
	);
};
